// extracted by mini-css-extract-plugin
module.exports = {"myCampaignsAction":"RouteTitle_myCampaignsAction__3i6IN","actionLabel":"RouteTitle_actionLabel__Sl00H"};